import { render, staticRenderFns } from "./CafeteriasSelector.vue?vue&type=template&id=2482061e"
import script from "./CafeteriasSelector.vue?vue&type=script&lang=js"
export * from "./CafeteriasSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports